import React, { useEffect, useState } from "react";
import SuccessVector from "Assets/successvector.png";
//Parent/home?StudentId=2804374
import Styles from "./Styles.module.scss";
import loadSuccess from "Assets/failedimage.png";
import { useNavigate } from "react-router";

import useStore from "store";
function Success() {
    const setPaymentModal = useStore((state: any) => state.setPaymentModal);
    const [timer, setTimer] = useState(5);
    const { Tab, setTab } = useStore((item: any) => item);

    const Navigate = useNavigate();
    useEffect(() => {
        const redirectTimeout = setTimeout(() => {
            setPaymentModal(false);
            setTab("WALLET TRANSACTIONS");
            window.close();
            console.log("11");
            /* if (localStorage.getItem("student")) {
                Navigate(
                    `/Parent/home?StudentId=${localStorage.getItem("student")}`
                );
            } */
        }, 5000); // 10 seconds in milliseconds
        const countdownInterval = setInterval(() => {
            setTimer((prevCountdown) => prevCountdown - 1);
        }, 1000); // Update countdown every second

        return () => {
            clearTimeout(redirectTimeout);
            clearInterval(countdownInterval);
            localStorage.removeItem("paymentLink");
        };
    }, []);
    return (
        <div className={Styles["container"]}>
            <div className={Styles["wrapper"]}>
                <div className={Styles["Success"]}>
                    <img src={loadSuccess} alt="loadSuccess" />
                    <p style={{ color: "red" }}>Transaction Failed</p>
                    <p style={{ margin: "0 1rem" }}>
                        <span style={{ fontWeight: "bold" }}>
                            Don't worry your money is safe.
                        </span>
                        If money is debited from your Account .If will be
                        refunded Automatically in 5-7 working days
                    </p>

                    <p>will Redirect in {timer} </p>
                </div>
                {/* <img src={SuccessVector} alt="SuccessVector" /> */}
            </div>
        </div>
    );
}

export default Success;
